import Image from 'next/image';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from '@dapp/multi-lib/sdaoui/Icon';
import SupportModal from 'components/SupportModal';
import { NETWORK_SWITCH_DISPLAY } from 'store/constants/chain';
import SwitchNetwork from 'structure/user/SwitchNetwork';
import { formatAddress } from 'structure/user/WalletConnect/helper/formate-address.const';
import { USER_TOKEN, WALLET_NAME } from 'utils/constants/local-storage-const';
import {
  TELEGRAM_LINK,
  TWITTER_LINK,
} from 'utils/constants/social-links.constant';
import { WalletConfigType } from '../../wallet-config-type.interface';
import { walletsConfig } from '../../wallet-config.const';
import { walletTypeCss } from '../../wallet-connect.styles';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localstorage';
import WalletSupport from '../../../../../../../packages/multi-lib/src/oldui/Navbar/WalletSupport';
import { Button } from '@dapp/multi-lib/sdaoui/Button';

type WalletManageProps = {
  address: string;
  disconnect: () => void;
};

export const WalletManage: React.FC<WalletManageProps> = ({
  address,
  disconnect,
}) => {
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const { t } = useTranslation('common');
  const currentSelectedWallet: WalletConfigType | undefined = useMemo(() => {
    const currentWallet = localStorage.getItem(WALLET_NAME);
    return walletsConfig().find(
      (wallet: WalletConfigType) => wallet.id === currentWallet
    );
  }, []);

  return (
    <>
      <div className='text-white'>
        <div className='flex h-5/6 flex-col justify-between gap-3'>
          {t('YOUR_NETWORK_IS')}:
          <SwitchNetwork networkDisplayType={NETWORK_SWITCH_DISPLAY.SWITCH} />
          <div className={walletTypeCss(true, true, false)}>
            <div className='mx-auto mb-2.5 flex items-center'>
              {currentSelectedWallet?.icon && (
                <Image
                  width={36}
                  height={36}
                  src={currentSelectedWallet.icon}
                  alt={currentSelectedWallet.id}
                />
              )}
              {currentSelectedWallet?.title && (
                <div className='ml-1.5'>{currentSelectedWallet?.title}</div>
              )}
            </div>
            <span className='text-center'>{formatAddress(address, true)}</span>
          </div>
          <Button
            onClick={() => {
              localStorage.removeItem(WALLET_NAME);
              localStorage.removeItem(LOCAL_STORAGE_KEYS.NETWORK);
              localStorage.removeItem(LOCAL_STORAGE_KEYS.CONNECTED);
              localStorage.removeItem(USER_TOKEN);
              disconnect();
            }}
          >
            {t('DISCONNECT_YOUR_WALLET')}
          </Button>
          <div>
            <p className='paragraph-xsmall text-center'>
              {t('IF_YOU_HAVE_QUESTION')}{' '}
              <span
                onClick={() => setIsSupportModalOpen(true)}
                className='cursor-pointer text-blue-300'
              >
                {t('SUPPORT')} .
              </span>
              {t('OR_FOLLOW_US')}
            </p>
            <div className='mt-2.5 flex justify-center'>
              {socialLinks.map((social, index: number) => (
                <a
                  key={index.toString()}
                  href={social.link}
                  target='_blank'
                  rel='noreferrer noopener'
                  className='mx-1.5'
                >
                  <Icon
                    icon={social.icon}
                    color={'#FFF'}
                    width='20'
                    height='18'
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      {isSupportModalOpen && (
        <SupportModal
          isSupportModalOpen={isSupportModalOpen}
          handleOnCloseModal={() => {
            setIsSupportModalOpen(false);
          }}
          title={t('SUPPORT')}
        >
          <WalletSupport />
        </SupportModal>
      )}
    </>
  );
};
const socialLinks: { icon: IconName; link: string }[] = [
  {
    icon: 'telegram',
    link: TELEGRAM_LINK,
  },
  // { icon: 'discord', link: DISCORD_LINK },
  { icon: 'x', link: TWITTER_LINK },
];
